module.exports = __webpack_public_path__ + "media/images/icons/time-attendance-09f6a6f94cddbef8433a4beb4b14718e.svg";